// extracted by mini-css-extract-plugin
export var categoryItemImage = "categoryItem-module--category-item-image--OquUP";
export var description = "categoryItem-module--description--akhwC";
export var item = "categoryItem-module--item--96Rvj";
export var itemTitle = "categoryItem-module--item-title--lqEoz";
export var price = "categoryItem-module--price--4J+po";